var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 409,
    viewBox: "0 0 217 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.3,
    clipPath: "url(#clip0_5671_31601)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-41.0862 248.979C-18.649 234.023 17.2315 208.091 35.1419 191.618C47.1432 199.427 60.427 205.652 71.4409 214.819C53.511 237.934 23.741 269.301 4.55077 291.386",
    fill: "#A75A3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8479 209.321L24.9949 198.292L54.2322 237.168L46.2614 246.502L11.8479 209.321Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8134 208.212L47.6058 247.961L-51.1081 352.829L-116.029 293.701L10.8134 208.212Z",
    fill: "#8DA6BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.377 139.501L36.6292 227.397L51.8836 240.9L144.689 169.013L113.377 139.501Z",
    fill: "#3F3737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.235 223.275L56.4455 237.376L59.7958 234.77L43.5165 219.508L40.235 223.275Z",
    fill: "#8DA6BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.734 105.41L123.843 106.448L98.9268 146.294C97.8226 148.061 98.0342 150.298 99.4313 151.669L134.9 186.462C136.393 187.935 138.805 187.983 140.534 186.579L178.042 156.028L179.092 154.7L124.739 105.423L124.734 105.41Z",
    fill: "#C6DFF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.65 174.249L121.717 109.835L108.232 131.396L140.53 186.567L155.65 174.249Z",
    fill: "#8DA6BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.458 94.2634L185.564 138.102C186.331 138.865 186.494 140.06 185.979 141.077L179.098 154.692C178.307 156.265 176.29 156.714 175.064 155.59L124.534 109.333C123.408 108.301 123.513 106.447 124.749 105.406L138.053 94.2084C139.086 93.3372 140.559 93.3605 141.463 94.2544L141.458 94.2634Z",
    fill: "#8DA6BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.262 126.995C209.364 113.045 207.443 93.0468 193.974 82.3273C180.504 71.6077 160.585 74.2261 149.483 88.1757C138.382 102.125 140.302 122.124 153.772 132.843C167.242 143.563 187.161 140.944 198.262 126.995Z",
    fill: "#3F3737"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.419 111.7C147.342 107.926 155.39 102.746 166.401 99.6693C183.538 94.883 198.061 97.9114 204.76 99.7727",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.661 103.677C146.867 100.016 154.74 94.1776 166.136 91.0842C182.919 86.5289 196.94 90.7575 202.307 92.6954",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.117 91.5791C150.637 88.7555 158.103 83.5424 168.993 81.5152C181.63 79.1656 191.735 82.4327 195.961 84.0722",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.302 119.84C150.908 116.134 162.419 110.815 177.646 109.307C189.074 108.177 198.639 109.572 205.165 111.074",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.328 128.492C157.418 125.812 168.135 123.193 180.869 122.505C188.38 122.095 195.137 122.435 200.957 123.093",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.574 138.646C175.8 133.723 170.62 125.675 167.543 114.664C162.757 97.5275 165.785 83.0035 167.646 76.3047",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.542 139.449C169.27 136.269 160.005 126.471 157.229 110.511C154.509 94.8974 159.636 82.7635 161.622 78.6252",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.854 137.455C159.015 134.481 151.464 125.784 149.387 112.059C147.234 97.8654 152.257 87.0219 154.124 83.4139",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.86 135.128C185.181 128.535 180.198 117.669 178.293 103.395C176.795 92.1133 177.733 82.5529 178.934 75.8945",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.925 128.606C194.207 121.737 191.278 112.047 190.385 100.189C189.81 92.4668 190.228 85.6591 190.973 80.1016",
    stroke: "#F1F1F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.245 185.293C129.98 191.147 124.57 198.021 117.707 199.214C123.845 206.853 113.011 213.567 105.919 213.7C108.336 214.625 107.486 219.169 106.385 221.115C104.5 225.556 100.205 224.879 95.8072 224.63C99.822 228.649 94.8801 234.329 90.1585 234.646C83.0173 235.84 68.9077 231.215 65.7135 224.253C65.0071 218.417 71.6948 214.75 76.9645 215.424C71.1927 210.793 81.2055 202.87 86.3301 203.663C83.5586 202.88 85.193 197.545 86.7962 195.683C89.7284 191.673 94.4612 191.472 99.3757 190.749C94.9074 184.91 100.441 179.71 106.451 179.219C112.208 178.353 120.137 181.307 124.263 185.302L124.245 185.293Z",
    fill: "#A75A3B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8567 190.147C103.47 191.405 112.284 195.222 117.698 199.208",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8483 204.075C93.2858 205.966 99.6377 210.308 106.31 213.927",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4715 215.531C82.6163 219.377 90.2675 220.351 96.1034 224.614",
    stroke: "#3F3737",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9453 193.039C41.5506 181.816 53.5718 173.673 66.8102 170.757C73.2 169.35 79.7932 169.124 86.2233 167.936C89.6946 167.292 93.1199 166.371 96.4502 165.184C98.0664 164.601 99.6992 163.959 101.41 163.83C103.129 163.705 104.987 164.199 106.061 165.55C107.058 166.809 107.193 168.599 106.738 170.143C106.282 171.687 105.316 173.022 104.286 174.26C100.956 178.247 96.7597 181.491 92.0684 183.704C87.0668 186.057 81.4476 187.309 77.1307 190.762C74.7631 192.649 72.9303 195.089 70.8008 197.244C64.3291 203.792 55.0335 207.451 45.847 207.076L33.941 193.048L33.9453 193.039Z",
    fill: "#A75A3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5671_31601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.76,
    height: 350.67,
    fill: "white",
    transform: "translate(23.3223) rotate(25.3834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLeft);
export default __webpack_public_path__ + "static/media/MediaLeft.2c108ea3ea689082f4c932bc4ede97b3.svg";
export { ForwardRef as ReactComponent };